import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  BaseSiteService,
  CmsService,
  LanguageService,
  ProductService,
  RoutingService,
} from '@spartacus/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CheckoutService } from 'src/app/shared/modules/checkout/checkout.service';
import { AccountOverviewService } from '../../account-overview.service';

@Component({
    selector: 'app-acc-overview-placeholder',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './acc-overview-placeholder.component.html',
    styleUrls: ['./acc-overview-placeholder.component.scss'],
    standalone: false
})
export class AccOverviewPlaceholderComponent implements OnInit, OnDestroy {
  accountNumber: string = null;
  compNameAdBanner = 'SanofiAccountOverviewBannerComponent4';
  compNameAdBanner2 = 'SanofiAccountOverviewBannerComponent2';
  compNameAdBanner3 = 'SanofiAccountOverviewBannerComponent3';
  compNameAdBanner6 = 'SanofiAccountOverviewBannerComponent6';
  compNameAdBanner1 = 'SanofiAccountOverviewBannerComponent';
  cmsResponse: any;
  productCodes: any;
  prodcutsInfo: any = [];
  prodDocs: any = [];
  prodDocus: any = [];
  fluResevartion: boolean;
  isTrue: boolean = true;
  isShow: boolean = false;
  cmsSub: Subscription;
  contentSub: Subscription;
  baseSub: Subscription;
  accountSub: Subscription;

  constructor(
    private readonly acService: AccountOverviewService,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: RoutingService,
    private readonly cmsData: CmsService,
    protected productService: ProductService,
    private readonly checkoutService: CheckoutService,
    private readonly sanitizer: DomSanitizer,
    private readonly lang: LanguageService,
    private readonly baseSiteService: BaseSiteService
  ) {}
  baseSiteId: string;
  ngOnInit(): void {
    this.contentSub = this.cmsData
      .getContentSlot('AccountOverviewPlaceholderSlot')
      .subscribe((cms) => {
        if (cms?.components) {
          this.isShow = true;
        }
      });
    this.baseSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((base) => (this.baseSiteId = base));
    this.lang.getActive().subscribe((base) => {
      if (base) {
        this.prodcutsInfo = [];
      }
    });
    this.accountSub = this.acService.userAccountIdDetailsData.subscribe(
      (acc) => {
        if (this.accountNumber === null) {
          this.accountNumber = acc?.defaultB2BUnit.uid;
          this.cdr.detectChanges();
        }
      }
    );

    this.cmsSub = this.cmsData
      .getComponentData('ProductMonographComponent')
      .subscribe((mon) => {
        this.cmsResponse = mon;
      });
  }

  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
    this.cmsSub?.unsubscribe();
    this.contentSub?.unsubscribe();
    this.accountSub?.unsubscribe();
  }

  navigateToAccountDetails() {
    this.router.goByUrl('/my-account/profile');
    this.checkoutService.tabSelection('Account information');
  }
  productMonograph() {
    this.productCodes = this.cmsResponse?.productCodes;
    this.productCodes = this.productCodes?.split(' ');
    this.productCodes?.forEach((element) => {
      this.productService.get(element).subscribe((res) => {
        if (res) {
          this.prodcutsInfo.push(res);
          this.cdr.detectChanges();
        }
      });
    });
  }
}
